/* CTR scroll reveal (snippets/ctr-scroll-reveal.liquid)
   Adds .is-revealed to [data-ctr-reveal] elements once they enter the viewport (runs once).
   Numbers marked [data-ctr-countup] inside a revealed element count up from 0. */
(function () {
  if (window.CtrScrollReveal) return;

  var root = document.documentElement;

  function countUp(el) {
    var text = el.textContent.trim();
    if (!/^\d+$/.test(text)) return;
    var target = parseInt(text, 10);
    var duration = 1000;
    var start = null;
    function step(time) {
      if (start === null) start = time;
      var progress = Math.min((time - start) / duration, 1);
      el.textContent = Math.round(target * (1 - Math.pow(1 - progress, 3)));
      if (progress < 1) requestAnimationFrame(step);
    }
    el.textContent = '0';
    requestAnimationFrame(step);
  }

  function reveal(el) {
    el.classList.add('is-revealed');
    el.querySelectorAll('[data-ctr-countup]').forEach(countUp);
  }

  function init() {
    if (!root.classList.contains('ctr-reveal-js')) return;
    var elements = document.querySelectorAll('[data-ctr-reveal]:not(.is-revealed)');
    if (!('IntersectionObserver' in window)) {
      elements.forEach(reveal);
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
    );
    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  window.CtrScrollReveal = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
